import {
  HTTP_INSERTBUDGET_FETCHING,
  HTTP_INSERTBUDGET_SUCCESS,
  HTTP_INSERTBUDGET_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_INSERTBUDGET_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_INSERTBUDGET_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_INSERTBUDGET_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
